export const dialog = () => {
  const dialog = document.querySelector("[data-wm-dialog]");

  if (!dialog) {
    return;
  }

  const dialogContent = dialog.querySelector("[data-wm-dialog-content]");

  const fillDialogContent = async (name) => {
    const container = document.querySelector(`[${name}]`);
    const fetchUrl = container.dataset.wmDialogFetch;

    if (fetchUrl) {
      await fetch(fetchUrl, { cache: "no-store" })
        .then((response) => response.text())
        .then((html) => {
          dialogContent.innerHTML = html;
        });
    } else {
      dialogContent.innerHTML = container.innerHTML;
    }
  };

  const closeDialog = () => {
    dialog.close();
    dialogContent.innerHTML = "";
  };

  const setCloseDialogEventListeners = () => {
    [...document.querySelectorAll("[data-wm-close-dialog-cta]")].forEach(
      (closeButton) => {
        closeButton.addEventListener("click", closeDialog);
      }
    );
  };

  const renderDialog = async (event) => {
    const querySelector = event.detail?.querySelector;

    const contentName = querySelector
      ? querySelector
      : event.currentTarget.dataset.wmOpenDialogCta;

    const querySelectorId = event.currentTarget.dataset?.wmDialogId
      ? event.currentTarget.dataset.wmDialogId
      : null;

    const element = querySelectorId
      ? `${contentName}='${querySelectorId}'`
      : contentName;

    wemove.triggerEvent("wm-showPreloader");

    await fillDialogContent(element);
    setCloseDialogEventListeners();

    wemove.triggerEvent("wm-hidePreloader");

    dialog.showModal();
    wemove.triggerEvent(`wm-dialogOpened::${element}`);
  };

  [...document.querySelectorAll("[data-wm-open-dialog-cta]")].forEach((cta) => {
    cta.addEventListener("click", renderDialog);
  });

  document.addEventListener("wm-openDialog", renderDialog);
  document.addEventListener("wm-closeDialog", closeDialog);
};
